import type { CleanNotificationWithRelations } from '~/database/supabase/notifications/types';

/**
 *   Count number of None Viewed occurances among notifications.
 */
export default function countViewedNotifications(notifications: CleanNotificationWithRelations[] | undefined | null) {
	if (!notifications) {
		return 0;
	}

	let count = 0;
	notifications.forEach((notification) => {
		if (!notification.viewed) {
			count++;
		}
	});

	return count;
}
